import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loading } from '@tcc-online/common-components';

import AuthSelectors from '../../selectors/AuthSelectors';

type PrivateRouteProps = {
    children?: ReactNode;
};

export default function PrivateRoute(props: PrivateRouteProps): JSX.Element {
    const { children } = props;
    const user = useSelector(AuthSelectors.getCurrentUser);
    const { isLoading, error } = user;

    const isLogged = AuthSelectors.useIsLogged();

    if (!isLogged) {
        return <Navigate to="/" replace relative="path" />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (isLoading) {
        return <Loading isLoading isTransparent={false} />;
    }

    return <>{children}</>;
}
